module.exports = __webpack_public_path__ + "img/client-wash_takeout_en.61e98789.svg";